import {PureComponent} from 'react';
import PropTypes from 'prop-types';
import root from 'window-or-global';
import throttle from 'lodash.throttle';

/* This component sets up and removes listener events
so the wrapped component can know when user is inactive */

class InactivityListener extends PureComponent {
    static propTypes = {
        children: PropTypes.node,
        onIdle: PropTypes.func,
        onReturnFromIdle: PropTypes.func,
        shouldListen: PropTypes.bool
    };

    state = {
        active: true
    };

    componentDidMount() {
        if (this.props.shouldListen) this.startTimer();
    }

    componentDidUpdate(prevProps) {
        const start = !prevProps.shouldListen && this.props.shouldListen;
        const stop = prevProps.shouldListen && !this.props.shouldListen;
        if (start) this.startTimer();
        if (stop) this.stopTimer();
    }

    componentWillUnmount() {
        this.removeActivityListeners();
        clearTimeout(this.timer);
    }

    removeActivityListeners = () => {
        root.removeEventListener('mousemove', this.throttledResetTimer, false);
    };
    startTimer = () => {
        // after 2 mins of inactivity, set user to idle
        this.timer = setTimeout(() => {
            const {onIdle} = this.props;
            root.addEventListener('mousemove', this.throttledResetTimer, false);
            if (this.state.active) {
                onIdle();
                this.setState({active: false});
            }
        }, 120000);
    };

    stopTimer = () => {
        const {onReturnFromIdle} = this.props;
        if (!this.state.active) {
            this.removeActivityListeners();
            clearTimeout(this.timer);
            onReturnFromIdle();
            this.setState({active: true});
        }
    };

    resetTimer = () => {
        this.stopTimer();
        this.startTimer();
    };

    // every 30 seconds
    throttledResetTimer = throttle(this.resetTimer, 30000);

    render() {
        return this.props.children;
    }
}

export default InactivityListener;
